import React from 'react'
import './styles.css'

interface Props {
    text?: string
    icon?: React.ReactNode
    color?: 'default' | 'success' | 'error' | '#94A3B8'
    className?: string
    classNameText?: string
}
export const Badge = ({
    icon,
    text,
    color = 'default',
    classNameText,
    className,
}: Props) => {
    return (
        <div
            className={`flex  items-center gap-2 bg-${color} ${
                className ? className : 'badge'
            }`}
        >
            {icon}
            <p className={`${classNameText ? classNameText : 'Text-[14px]'}`}>
                {text}
            </p>
        </div>
    )
}
